import { FormikProps } from 'formik';
import { Dispatch } from 'redux';
import Select from 'react-select';
// import Cleave from 'cleave.js/react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';

import { useEffect } from 'react';
import FluidContainerClean from 'Components/pos2u/Wrappers/FluidContainer';
// import { ChromePicker } from 'react-color';

import { ManageTagFormType } from 'types/tag/TagTypes';
import {
  setCountTagSubmit,
  setShowAllValidateTagErrors,
  setTagFormErrorCount,
} from 'slices/tags/reducer';
import { ActiveStatusOptions, TagTypes } from 'pages/Tags/TagConstants';
import { CustomReactSelectStyles } from '../styles/customStyles';
import { SelectOptions } from 'types/common/FormTypes';
// import { truncateText } from 'utils/common/String';
import CustomColorPicker from 'Components/pos2u/Pickers/CustomColorPicker';

const ManageTagForm = ({
  dispatch,
  formik,
}: {
  dispatch: Dispatch;
  formik: FormikProps<ManageTagFormType>;
}) => {
  const { t } = useTranslation();
  // const infoState = useSelector((state: RootState) => state.Info);
  // const { branchCodes } = infoState;
  const layoutState = useSelector((state: RootState) => state.Layout);
  const { layoutModeType } = layoutState;
  const isDarkMode = layoutModeType === 'dark';
  const tagState = useSelector((state: RootState) => state.Tags);
  const { TagModal } = tagState;

  useEffect(() => {
    dispatch(setTagFormErrorCount(Object.keys(formik.errors).length));
  }, [formik.errors, dispatch]);

  return (
    <>
      <div className={`mb-3 row`}>
        <Label htmlFor="name" className="col-sm-4 col-form-label">
          {t('Tag Name')}
          <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Input
              type="text"
              name={`name`}
              id="name"
              value={formik.values.name || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              // onBlur={formik.handleBlur}
              className="me-2"
              maxLength={50}
            />
            {(formik.touched.name && formik.errors.name) ||
            (formik.isValid === false &&
              formik.errors.name &&
              TagModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.name}</div>
            ) : null}
          </FluidContainerClean>
        </Col>
      </div>
      <div className={` row`}>
        <Label htmlFor="type_select" className="col-sm-4 col-form-label">
          {t('Type')}
          <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            {/* <Input
              type="text"
              name={`type`}
              value={formik.values.type || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="me-2"
            /> */}
            <FormGroup key={1}>
              <Select
                styles={CustomReactSelectStyles(isDarkMode)}
                id="type_select"
                name="type_select"
                aria-label="type_select"
                data-testid="type_test"
                options={TagTypes(t)}
                value={
                  formik.values.type
                    ? TagTypes(t)
                        .flatMap((group: SelectOptions) => group.options)
                        .find(
                          (option: { value: string }) =>
                            option.value === formik.values.type
                        )
                    : null
                }
                onChange={(option: { value: string }) => {
                  formik
                    .setFieldValue('type', option?.value)
                    .then(() => formik.setFieldTouched('type', true));
                }}
                onBlur={() => {
                  formik.setFieldTouched('type', true);
                }}
                placeholder={t('ProductPage_PleaseSelect')}
              />

              {(formik.touched.type && formik.errors.type) ||
              (formik.isValid === false &&
                formik.errors.type &&
                TagModal.showAllValidateErrors === true) ? (
                <div className="text-danger">{formik.errors.type}</div>
              ) : null}
            </FormGroup>
          </FluidContainerClean>
        </Col>
      </div>

      <div className={`mb-3 row`}>
        <Label htmlFor="description" className="col-sm-4 col-form-label">
          {t('Description')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <textarea
              // className="form-control"
              className="form-control p-0 m-0"
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows={3}
              maxLength={255}
            />
            {(formik.touched.description && formik.errors.description) ||
            (formik.isValid === false &&
              formik.errors.description &&
              TagModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.description}</div>
            ) : null}
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="color_btn" className="col-sm-4 col-form-label">
          {t('Color')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <CustomColorPicker formik={formik} />
            {(formik.touched.color && formik.errors.color) ||
            (formik.isValid === false &&
              formik.errors.color &&
              TagModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.color}</div>
            ) : null}
          </FluidContainerClean>
        </Col>
      </div>

      <div className="mb-3 row">
        <Label htmlFor="active" className="col-sm-4 col-form-label">
          {t('Status')} <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={8}>
          <div className="mt-2">
            <FormGroup key={5}>
              {ActiveStatusOptions(t).map(
                (p: { label: string; value: string }, _index: any) => (
                  <div key={p.value} className="form-check form-check-inline">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="active"
                      id={p.label}
                      value={p.value}
                      checked={formik.values.active === p.value}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <Label className="form-check-label" htmlFor={p.label}>
                      {p.label}
                    </Label>
                  </div>
                )
              )}
            </FormGroup>
            {(formik.touched.active && formik.errors.active) ||
            (formik.isValid === false &&
              formik.errors.active &&
              TagModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.active}</div>
            ) : null}
          </div>
        </Col>
      </div>
      <Row>
        <Col xs={12} sm={12} className="text-center">
          <div className="mb-3">
            <Row>
              <Col xs={0} sm={4}></Col>

              <Col xs={5} sm={3}>
                <Button
                  block
                  color="success"
                  type="submit"
                  id="edit-price-save"
                  disabled={
                    TagModal.FormErrorCount !== 0 || formik.isSubmitting
                  }
                  // disabled={formik.isSubmitting}
                  onClick={async () => {
                    await formik.setTouched(
                      Object.keys(formik.initialValues).reduce(
                        (acc, key) => ({ ...acc, [key]: true }),
                        {}
                      )
                    );
                    dispatch(setShowAllValidateTagErrors(true));
                    dispatch(setCountTagSubmit());
                  }}
                >
                  {t('Btn_Save')}
                </Button>
              </Col>
              {/* <Col xs={1} sm={3}></Col> */}
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ManageTagForm;
